import React,{useContext} from 'react'
import StudentNav from '../Navbars/StudentNav'
import AdminNav from '../Navbars/AdminNav'
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import { UserContext } from '../UserContext';
import Footer from '../Footer'
import './CodingCourseDetails.css'
import { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import "../MathPortal/Slider.css";
import "../MathPortal/MathCourseDetails.css";
import "../MathPortal/MathPortalResponsive.css";
import "./ScratchProgramming.css"
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import pic1 from './CodingCourseImages/scratch.png'
import minecraft from './CodingCourseImages/minecraft.png' // Add this image import
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import FeeStructure from '../components/FeeStructure';
import ScrP from './CodingCourseImages/scratchDetailBackground.png'
import Testimonials from '../Testimonials'

const ScratchProgramming = ({selectedCourse}) => {
  const handleCourseSelect = (course) => {
    console.log("Selected Course in Home:", course);
    selectedCourse(course);
  };

 const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo,userInfo } = useContext(UserContext);   
 
    useEffect(() => {
      const fetchData = async () => {
       await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
          credentials: 'include',
        }).then(response => {
            console.log("Response:",response);
          response.json().then(userInfo => {
            console.log("userinfo:",userInfo);
            setUserInfo(userInfo);

            if(userInfo?.usertype)
            {
              const uType=userInfo?.usertype;
              setUserRole(uType);
            }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          console.log("Uname: ", uname);
          console.log("Avatar: ", avatar);

          })
          .catch(err=> console.log("Error in useeffect:",err))
        });
      }
      fetchData();
    }, [isAdmin, isTeacher, isStudent, isGuest]);
  const determineUserRole = (usertype) => {
        console.log("In home.js:",usertype)
        if(usertype === 'Student')
          return "Student";
        else if(usertype === 'Teacher')
          return "Teacher";
        else if(usertype === 'Admin')
          return "Admin";
        else
          return "guest";
  };
  
  
 const navigate=useNavigate();
  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    console.log("Calling setUserRole.")
    setUserRole(userRole);
  };

  function onLogout() {
      console.log("inside Onlogout.");
      fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
        credentials: 'include',
        method: 'POST',
      });
      setUserInfo(null);
      setUserRole('guest');
    }
      
      const username = userInfo?.username;
      const _avatar_ = userInfo?.avatar;
  return (
    <div >
      
     {/* Navbar */}
     {username && (
        <>
        {isAdmin && <AdminNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
        {isTeacher && <TeacherNav  username={username} avatar={_avatar_} onLogout={onLogout}/>}
        {isStudent && <StudentNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
        )}  
        {!username && (
          <>
          {isGuest && <GuestNav onLogin={onLogin} />}
          </>
        )}
  
       <div className="ScratchProg-Background">
          <section className="section">
            <p className="PageHead"style={{ color: "#8b0194" }}>Minecraft with Scratch Programming</p>
            <div className="PageDesc">
            <div style={{display:"flex"}}>
              <p style={{
                fontFamily: "KG Primary Whimsy,VanillaMilk,'DM Sans', sans-serif",
                color: "white",
                textAlign: "left",
                padding: "30px",
                fontSize: "22px",
                zIndex: 1,
                color: "#8b0194",
                width:"70%"
                
              }}>
              Polymath-kids offers an exciting Minecraft-themed Scratch programming course where kids learn coding through creating their own Minecraft adventures. Our online classes are available in both 1:1 and group formats, taught by experienced computer science instructors who make learning fun and engaging.
              </p>
              <img style={{minWidth:"250px", maxWidth:"450px"}} src={ScrP}></img>
              </div>
              <div className="btn-row d-flex btn-row-resp btn-row-resp1">
                <div style={{ width: "auto", height: "50px" }}>
                  <a className="btn-row-resp button btn-color-course" href="#course">Course Structure</a>
                </div>
               
                <div style={{ width: "auto", height: "50px" }}>
                  <a className=" btn-row-resp button btn-color-fee" href="#fee">Fee Structure</a>
                </div>
                <div style={{ width: "auto", height: "50px" }}>
                  <a className=" btn-row-resp button btn-color-Testimonal" href="#testimonal">Testimonals</a>
                </div>
                <div style={{ width: "auto", height: "50px" }}>
                  <a className=" btn-row-resp button btn-color-Faq" href="#Faq">Faqs</a>
                </div>
                <div style={{ width: "auto", height: "50px" }}>
                <a className=" btn-row-resp button btn-color-registered" href="#">Get Registered</a> 
                </div>
              </div>
            </div>
          </section>
          <div className="overlay"></div>
        </div>

          {/* Intro text */}
        <div className='scratch-background'>
        <section className="section">
            <p className="PageHead" style={{ color: "#8b0194" }}>What is Minecraft with Scratch?</p>
            <div className="PageDesc">
              <p style={{
                  color: "#8b0194",
                  marginTop: "2vh",
                  fontSize: "4vh",
                  fontFamily: "sans serif",
                }}>
              This unique course combines the creativity of Minecraft with the educational power of Scratch programming. Students will learn fundamental coding concepts while building their own Minecraft-style games and animations in Scratch's block-based environment.
<br />
<br />
Through this course, students will master core programming concepts like loops, conditionals, variables, and event handling - all while creating Minecraft-inspired projects. Each lesson builds upon the previous one, gradually increasing in complexity as students develop their coding skills.
<br />
<br />
The visual nature of Scratch makes it perfect for young learners to grasp programming concepts without getting bogged down by syntax. By using the familiar Minecraft theme, we keep students engaged and motivated throughout their coding journey.
<br />
<br />
By the end of this course, students will have created a complete Minecraft-style game with multiple levels, character interactions, and game mechanics - all while developing valuable computational thinking skills that form the foundation for more advanced programming.
              </p>    
            </div>
          </section>
        </div>
        
        {/* Course Structure and Syllabus */}
        <section className="section course-structure" id="course">
          <p className="PageHead" style={{ color: "#8b0194" }}>
            Course Structure and Syllabus
          </p>
          <h4 className="H4_Heading" style={{color:"#8b0194",fontFamily:"sans-serif"}}>
              <b>
                Course Objectives
              </b>
          </h4>
          <ul style={{color:"#8b0194",fontFamily:"sans-serif"}}>
            <li>Learn fundamental programming concepts through Minecraft-themed projects</li>
            <li>Develop problem-solving and logical thinking skills</li>
            <li>Create interactive games with characters, items, and multiple levels</li>
            <li>Understand game design principles and mechanics</li>
            <li>Build confidence in computational thinking and creativity</li>
          </ul>
          
          <div>
            <p className='moduleSection' >
                <img src={pic1} alt=""style={{width:"2em",height:"2em"}} />
                Minecraft with Scratch Course
            </p>
          </div>

          {/* Module one */}
          <div className="modules">
            {/* round box */}
            <div className="round-box">
              <p style={{ marginTop: "5vh", color: "#cff7d5" }}>
                {" "}
                Module
                <br />
                1
              </p>
            </div>
            {/* small boxes */}
            <div className="small-box" style={{ color: "#249935" }}>
              <p style={{ margin: "auto" }}>
                Lessons
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>
                  12
                </p>
              </p>

              <div
                className="small-box sm-box"
              >
                <p style={{ margin: "auto" }}>
                  Projects
                  <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>
                    1
                  </p>
                </p>
              </div>
            </div>

            <div className="large-box" style={{ color: "#249935" }}>
              <p style={{ margin: "auto" }}>
              Minecraft Game Development
                <p
                  style={{
                    fontWeight: "lighter",
                    fontSize: "15px",
                    marginBottom: "0px",
                  }}
                >
                  Students will progress from basic Scratch concepts to creating a complete Minecraft-style game. The course covers sprite creation, game mechanics, level design, character interactions, and more - all within the fun Minecraft theme that kids love.
                </p>
              </p>
            </div>
          </div>

          

          <h6 style={{color:"#8b0194",fontFamily:"sans-serif", marginTop: "30px"}}>
            <b>Create Your Own Minecraft Game</b>
        </h6>
        <div className="activityImagesContainer" style={{display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap"}}>
    <div style={{flex: "1", minWidth: "300px", maxWidth: "500px", textAlign: "center", padding: "20px"}}>
        <img src={minecraft} alt="Minecraft Game" className='ActivityImages' style={{maxWidth: "100%", height: "auto", borderRadius: "10px"}}/>
    </div>
    
    </div>
    <p>Minecraft Adventure Game</p>
        {/* <div className="activityImagesContainer">
          <div class="row justify-content-center">
            <div class="col-lg-6 mx-3 text-center">
                <img src={minecraft} alt="Minecraft Game" className='ActivityImages' style={{maxWidth: "400px"}}/>
                <p>Minecraft Adventure Game</p>
            </div>
          </div>
        </div> */}
        </section>

        {/* Fee Structure */}
        <FeeStructure subject="Coding"/>

        <Testimonials />

        {/* Faqs */}
        <div style={{ maxWidth: '100%', backgroundColor: '#edffff' }} id="Faq">
          <MDBContainer className="mt-0" style={{ maxWidth: '180vh' }}>
            <MDBAccordion alwaysOpen initialActive={1} >
              <div className="text-center PageHead" style={{ color: "#8b0194" }}> FAQs</div>
              <MDBAccordionItem collapseId={1} headerTitle="Q: What will my child learn in this Minecraft Scratch course?" >
                <strong>A: </strong>
                Your child will learn fundamental programming concepts through creating a Minecraft-style game in Scratch. They'll master sprite creation, game mechanics, level design, and interactive elements while developing problem-solving and logical thinking skills.
              </MDBAccordionItem>
              <MDBAccordionItem collapseId={2} headerTitle="Q: Does my child need any prior coding experience?">
                <strong>A: </strong>
                No prior coding experience is needed! This course is designed for beginners and will teach all the necessary Scratch programming concepts through the engaging Minecraft theme.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={3} headerTitle="Q: What age group is this course suitable for?">
                <strong>A: </strong>
                This course is ideal for children aged 8-14. The Minecraft theme keeps younger students engaged, while the programming concepts provide appropriate challenge for older students.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={4} headerTitle="Q: What will my child create by the end of the course?">
                <strong>A: </strong>
                By the end of the course, your child will have created their own Minecraft-style game with multiple levels, character interactions, items, challenges, and game mechanics - all built in Scratch.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={5} headerTitle="Q: How does learning Scratch help with future programming?">
                <strong>A: </strong>
                Scratch teaches fundamental programming concepts like loops, conditionals, and variables in a visual way. These concepts directly translate to text-based programming languages, giving students a strong foundation for future coding education.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={6} headerTitle="Q: What technical requirements are needed for this course?">
                <strong>A: </strong>
                Students just need a computer with internet access to use the Scratch platform. No special software or powerful hardware is required.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={7} headerTitle="Q: Will my child need a Minecraft account for this course?">
                <strong>A: </strong>
                No, this course uses Scratch to create Minecraft-style games but doesn't require any Minecraft accounts or licenses. Everything is built within the Scratch platform.
              </MDBAccordionItem>

              <MDBAccordionItem collapseId={8} headerTitle="Q: How is this different from regular Scratch programming courses?">
                <strong>A: </strong>
                This course uses the popular Minecraft theme to teach programming concepts, which makes learning more engaging and relatable for students who enjoy Minecraft. The projects are all Minecraft-inspired while teaching core coding skills.
              </MDBAccordionItem>
            </MDBAccordion>
          </MDBContainer>
        </div>

        {/* Footer */}
        <Footer/>
    </div>
  )
}

export default ScratchProgramming